var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PdfTemplateEditorDialog',{attrs:{"open":_vm.open,"template-type":"receipt","value":_vm.receiptTemplate,"tenant-id":_vm.tenantId,"pdf-booking-layout":_vm.pdfBookingLayout,"pdf-booking-table-meta":_vm.pdfBookingTableMeta},on:{"close":function($event){return _vm.$emit('close')},"submit":_vm.onSubmit}})
}
var staticRenderFns = []

export { render, staticRenderFns }